import React from "react";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle({ compact = false }) {
  const { theme, setTheme } = useTheme();
  const opts = [
    { key: "light", icon: Sun, label: "Light" },
    { key: "dark",  icon: Moon, label: "Dark" },
    { key: "system", icon: Monitor, label: "System" },
  ];
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-card p-1" role="tablist" aria-label="Theme">
      {opts.map(({ key, icon: Icon, label }) => {
        const active = theme === key;
        return (
          <button
            key={key}
            role="tab"
            aria-selected={active}
            aria-label={`Switch to ${label} theme`}
            data-testid={`theme-toggle-${key}`}
            onClick={() => setTheme(key)}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium transition-colors ring-focus ${
              active ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {!compact && <span>{label}</span>}
          </button>
        );
      })}
    </div>
  );
}
